// DS: CO0.1M
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Sticky from '../../../Sticky';
import MobileSubmissionDetailsHeader from '../../../SubmissionDetails/MobileSubmissionDetailsHeader';
import SiteHeader from '../../../SiteHeader';
import { useDuperbrowseViewType } from '../../../Duperbrowse/DuperbrowseViewContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
const DeviationPageHeader = ()=>{
    const isMobile = useContext(MobileContext);
    const { isInDuperbrowse } = useDuperbrowseViewType();
    const isSeoHeader = useFlag('seo_mobile_header');
    if (!isMobile) {
        return /*#__PURE__*/ React.createElement(SiteHeader, null);
    }
    if (isInDuperbrowse || !isSeoHeader) {
        return /*#__PURE__*/ React.createElement(Sticky, {
            marginTop: -1
        }, (isStuck)=>/*#__PURE__*/ React.createElement(MobileSubmissionDetailsHeader, {
                isSticky: true,
                isStuck: isStuck
            }));
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SiteHeader, null), /*#__PURE__*/ React.createElement(MobileSubmissionDetailsHeader, {
        isSticky: false
    }));
};
DeviationPageHeader.displayName = 'DeviationPageHeader';
export default DeviationPageHeader;
